const Sentry = require('@sentry/browser')
const log = require('log').create('raven')  

/*

TODO
- whitelistUrls: [] ?

*/

function ensureMessageIsAString(msg, options) {
    switch (typeof msg) {
        case 'object':
            try {
                const json = JSON.stringify(msg)
                options.extra = options.extra || {}
                options.extra.thrown_object = json
                return {
                    msg: `Object thrown: ${json}`,
                    options,
                }

            } catch (err) {
                options.extra = options.extra || {}
                options.extra.thrown_object = msg
                options.extra.parse_err = err
                return {
                    msg: 'Object thrown: unable to stringify',
                    options,
                }
            }
        default:
            return { msg, options }
    }
}

const SentryWrapper = {

    VERSION: 'mock',

    initialize({ dsn, commit, environment }) {
        // to disable Raven in dev, do `localStorage.setItem('client.raven.disabled', true)`
        // this prevents Raven from wrapping errors and makes the call stack much easier to read
        if (__DEBUG__) {
            try {
                if (localStorage.getItem('client.raven.disabled')) {
                    log('Raven disabled')
                    return
                }
            } catch {
                // don't care
            }
        }

        // don't install Raven unless dsn key is provided
        if (dsn) {

            // create a release tag like production-47ef083
            // but only if environment and commit sha are provided
            const release = (
                commit
                && environment
                && `${environment}-${commit}`
            )

            Sentry.init({
                dsn,
                environment,
                release,
                replaysSessionSampleRate: 0,
                replaysOnErrorSampleRate: 1,
                integrations: [
                    Sentry.replayIntegration({
                        maskAllText: false,
                        blockAllMedia: false,
                    }),
                ],
                denyUrls: [/https:\/\/cdn.apigateway.co\//],
            })

            this.VERSION = Sentry.VERSION
            this.Sentry = Sentry

            const captureMessage = this.Sentry.captureMessage
            this.Sentry.captureMessage = function wrapCaptureMessage(input_msg, input_options) {
                const { msg, options } = ensureMessageIsAString(input_msg, input_options)
                captureMessage.call(this, msg, options)
            }
        }
    },

}

const mock_methods = [
    'captureMessage',
    'captureException',
    'setUser',
]

mock_methods.forEach((method_name) => {
    const logger = log.create('raven', method_name)
    SentryWrapper[method_name] = function wrapper() {
        if (this.Sentry) {
            this.Sentry[method_name].apply(this.Sentry, arguments)
        }
        logger.apply(logger, arguments)
    }
})

module.exports = SentryWrapper
